import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DestinoRoutingModule } from './destinos-routing.module';
import { DestinosPage } from 'src/app/pages/destino/destinos-page/destinos-page.component';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import { LoaderModule } from '../loader/loader/loader.module';
import { PartialModule } from '../partial/partial.module';
import { DestinoItemModule } from './destino-item/destino-item.module';
import { ModuloModule } from '../modulo/modulo.module';

@NgModule({
  declarations: [
    DestinosPage
  ],
  exports: [
    DestinosPage
  ],
  imports: [  
    ModuloModule,
    DestinoItemModule,
    PartialModule, 
    LoaderModule,
    LazyLoadImageModule,
    CommonModule,
    DestinoRoutingModule
  ]
})
export class DestinosModule { }
